import { useState, useEffect, useCallback } from 'react';
import apiV2 from '@/middlewares/apiV2';

/**
 * Custom hook to fetch the products catalog
 * @returns {{
 *   products: Array,
 *   loading: boolean,
 *   error: any,
 *   refetch: Function
 * }}
 */
const useProducts = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProducts = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await apiV2.get('/products');

            setProducts(response.data.data || []);
        } catch (err) {
            console.error('Error fetching products:', err);
            setError(err.response?.data?.message || 'Failed to fetch products');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    return {
        products,
        loading,
        error,
        refetch: fetchProducts
    };
};

export default useProducts;
